import React, { useEffect } from 'react'
import { base_url } from '../Api/Api';
import Cookies from 'universal-cookie';

const AdminLogin = (props) => {

    useEffect(() => {
        
        base_url.post(`login-with-user`, { 'rand_id': props.match.params.id })
            .then(response => {
                const cookies = new Cookies()
                cookies.set("api_key", response.data.token, {
                    maxAge: 604800,
                    path: "/",
                })
                localStorage.setItem('logined', JSON.stringify(true))
                props.history.push(`/`)
                window.location.reload()
            })
            .catch(error => {
                if (error.response != undefined) {
                    props.history.push(`/Entrance`)
                }
            })
    }, [])

    return (
        <div className="redirect__samsung"></div>
    );
}

export default AdminLogin;